import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/services/core/api.service';
import { TermsAndConditionsModel } from './models/terms-and-conditions.model';
import { Observable } from 'rxjs';
import { TermsAndConditionsStore } from './terms-and-conditions.store';
import { TermsAndConditionQuery } from './terms-and-conditions.query';
import { map, tap } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/core/logging.service';
import { TermsAndConditionsType } from './models/terms-and-conditions-type.model';
import { config } from '../../shared/config';

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionsService {
  constructor(
    private api: ApiService,
    private termsAndConditionsStore: TermsAndConditionsStore,
    private termsAndConditionsQuery: TermsAndConditionQuery,
    private logService: LoggingService
  ) {}

  /** Fetch all terms and conditions and put them in the store.
   * @param selectedType terms and condition type
   * @param lcid language variant to be displayed
   * @param clubId get the clubId of the user
   */
  private fetchTermsAndConditions(
    selectedType: TermsAndConditionsType,
    lcid: string,
    clubId: number = 1
  ): Observable<TermsAndConditionsModel[]> {
    this.logService.debug(`Fetching ${TermsAndConditionsType[selectedType]} Terms and Conditions`);

    return this.api.get<TermsAndConditionsModel>(`terms/all/${selectedType}/${clubId}`).pipe(
      tap((terms) => {
        terms.forEach((term) => {
          term.Type = selectedType;
        });
        this.termsAndConditionsStore.add(terms);
      }),
      map((terms) => terms.filter((term) => term.LCID === +lcid))
    );
  }

  /** Gets terms and conditions for a specific type
   * @param selectedType terms and condition type
   * @param lcid (Optional) language variant to be displayed. If not specified, config default lcid is used.
   */
  getTermsAndConditions(
    selectedType: TermsAndConditionsType,
    lcid?: string,
    clubId: number = 1
  ): Observable<TermsAndConditionsModel[]> {
    return this.termsAndConditionsQuery.hasTerms(selectedType)
      ? this.termsAndConditionsQuery.selectTermsAndConditions(selectedType, lcid ? +lcid : +config.defaultLcid)
      : this.fetchTermsAndConditions(selectedType, lcid ? lcid : config.defaultLcid, clubId);
  }
}
